export type SnippetCategoryKey =
  | "form"
  | "display"
  | "feedback"
  | "navigation"
  | "layout";

export type SnippetCategory = {
  key: SnippetCategoryKey;
  label: string;
  description: string;
};

export const categories: SnippetCategory[] = [
  {
    key: "form",
    label: "Form（入力）",
    description: "入力系リーフとフォーム用の共通器。",
  },
  {
    key: "display",
    label: "Display（表示）",
    description: "Badge や Label など、データ表示に使う要素。",
  },
  {
    key: "feedback",
    label: "Feedback（通知・状態）",
    description: "アラート・ローディング等のフィードバック。",
  },
  {
    key: "navigation",
    label: "Navigation（導線）",
    description: "ページ遷移やドロップダウン等。",
  },
  {
    key: "layout",
    label: "Layout（構造）",
    description: "ページ構造・セクション用の枠。",
  },
];
